export interface CabinaSettingsConfig {
  activarCabina: boolean;
  mensajesAnonimos: boolean;
  requiereRegistro: boolean;
  slowMode: boolean;
  slowModeSegundos: number;
  autoModeracion: boolean;
  autoRespuesta: boolean;
  mensajeBienvenida: string;
  mensajeFueraHorario: string;
  mensajeAutoRespuesta: string;
  palabrasProhibidas: string[];
  maxMensajesPorUsuario: number;
}

export const defaultCabinaSettings: CabinaSettingsConfig = {
  activarCabina: true,
  mensajesAnonimos: false,
  requiereRegistro: true,
  slowMode: false,
  slowModeSegundos: 15,
  autoModeracion: true,
  autoRespuesta: false,
  mensajeBienvenida: '¡Bienvenido a la cabina de Radio Frecuencia! Compartí tu mensaje con nosotros. Respetá a los demás oyentes.',
  mensajeFueraHorario: 'La cabina está cerrada en este momento. Volvé durante nuestros programas en vivo. ¡Te esperamos!',
  mensajeAutoRespuesta: '¡Gracias por tu mensaje! Nuestro equipo lo recibió y lo leeremos al aire pronto.',
  palabrasProhibidas: ['spam', 'ofensivo', 'insulto', 'estafa', 'engaño', 'falso', 'droga', 'apuesta', 'violencia'],
  maxMensajesPorUsuario: 5,
};

export const slowModeOptions = [
  { value: 5, label: '5 segundos' },
  { value: 10, label: '10 segundos' },
  { value: 15, label: '15 segundos' },
  { value: 30, label: '30 segundos' },
  { value: 60, label: '1 minuto' },
  { value: 120, label: '2 minutos' },
];

export const maxMensajesOptions = [
  { value: 1, label: '1 mensaje' },
  { value: 3, label: '3 mensajes' },
  { value: 5, label: '5 mensajes' },
  { value: 10, label: '10 mensajes' },
  { value: 20, label: '20 mensajes' },
  { value: 0, label: 'Sin límite' },
];